import { m } from "framer-motion";

interface ToggleSwitchProps {
  leftLabel: string;
  rightLabel: string;
  value: "left" | "right";
  onChange: (value: "left" | "right") => void;
  leftIcon?: React.ComponentType<{ className?: string }>;
  rightIcon?: React.ComponentType<{ className?: string }>;
}

export function ToggleSwitch({
  leftLabel,
  rightLabel,
  value,
  onChange,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
}: ToggleSwitchProps) {
  return (
    <div className="inline-flex p-0.5 bg-muted rounded-lg">
      <div className="relative flex">
        {/* Sliding background - positioned absolutely */}
        <m.div
          className="absolute inset-y-0 bg-card rounded-md shadow-sm"
          initial={false}
          animate={{
            x: value === "left" ? 0 : "100%",
          }}
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 30,
          }}
          style={{
            width: "50%",
          }}
        />
        
        {/* Left option */}
        <button
          onClick={() => onChange("left")}
          className={`
            relative z-10 px-3 py-1 rounded-md text-xs font-medium transition-colors duration-200
            flex items-center justify-center gap-1 min-w-[65px]
            ${value === "left"
              ? "text-foreground"
              : "text-muted-foreground hover:text-foreground"
            }
          `}
        >
          {LeftIcon && <LeftIcon className="w-3.5 h-3.5" />}
          {leftLabel}
        </button>
        
        {/* Right option */}
        <button
          onClick={() => onChange("right")}
          className={`
            relative z-10 px-3 py-1 rounded-md text-xs font-medium transition-colors duration-200
            flex items-center justify-center gap-1 min-w-[65px]
            ${value === "right"
              ? "text-foreground"
              : "text-muted-foreground hover:text-foreground"
            }
          `}
        >
          {RightIcon && <RightIcon className="w-3.5 h-3.5" />}
          {rightLabel}
        </button>
      </div>
    </div>
  );
}